import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
} from "react-icons/fa";

const Social = (props) => {
  const links = [
    { href: props.site.facebookLink, icon: <FaFacebookF /> },
    { href: props.site.twitterLink, icon: <FaTwitter /> },
    { href: props.site.instagramLink, icon: <FaInstagram /> },
    { href: props.site.tikTokLink, icon: <FaTiktok /> },
    { href: props.site.linkedInLink, icon: <FaLinkedinIn /> },
  ].filter((item) => item.href);

  if (!links.length) return null;

  return (
    <div className={`socialRow ${props.compact ? "socialRow--compact" : ""}`}>
      {links.map((item, idx) => (
        <a key={idx} href={item.href} rel="noopener noreferrer" target="_blank" className="socialRow__link">
          {item.icon}
        </a>
      ))}
    </div>
  );
};

export default Social;
